import type { SeoResolver } from '../types';

/** SEO for a selected police station. Moved verbatim from SEO.tsx. */
export const policeSeoResolver: SeoResolver = (ctx) => {
  const station = ctx.selections.policeStation;
  if (!station) return null;

  const { siteName, layerName } = ctx;
  const p = station.properties;

  return {
    title: `${p.ps_name || 'Police Station'} | ${layerName} | ${siteName}`,
    description: `View jurisdictional boundaries and contact details for ${p.ps_name || 'this police station'}. Locate government services with precision GIS on ${siteName}.`,
    breadcrumbLabel: p.ps_name || ''
  };
};
